export const FEATURED_BADGE_STATES = [
  { value: "closed", label: "Cerrado" },
  { value: "danger", label: "Peligro" },
  { value: "urgent", label: "Urgente" },
  { value: "soon", label: "Pronto" },
  { value: "warning", label: "Advertencia" },
  { value: "notice", label: "Aviso" },
];

export interface FeaturedBadgeScope {
  tenantId: string | null;
  eventTypeId: number | null;
  eventSubTypeId: number | null;
}

export interface FeaturedBadgeRule {
  id: number;
  tenantId: string | null;
  tenantName?: string | null;
  eventTypeId: number | null;
  eventSubTypeId: number | null;
  // Enriquecidos solo para mostrar en la tabla (no se envian a la API).
  // Coinciden con AdminRulesBaseRow (eventTypeName sin null).
  eventTypeName?: string;
  eventSubTypeName?: string | null;
  slug: string;
  label: string;
  thresholdMinutes: number;
  colorVariant: number;
  active: boolean;
  createdAt?: string;
}

export interface FeaturedBadgeRuleCreatePayload {
  tenantId: string | null;
  eventTypeId: number | null;
  eventSubTypeId: number | null;
  slug: string;
  label: string;
  thresholdMinutes: number;
  colorVariant: number;
  active: boolean;
}

export interface FeaturedBadgeRuleUpdatePayload extends FeaturedBadgeRuleCreatePayload {
  id: number;
}

export interface FeaturedBadgeRuleEntryValues {
  key: string;
  id?: number; // Needed to track existing labels when editing a grouped rule
  label?: string;
  slug?: string;
  thresholdMinutes?: number;
  colorVariant?: number;
}

export interface FeaturedBadgeRuleFormValues {
  tenantId?: string;
  eventTypeId?: number;
  eventSubTypeId?: number | null;
  entries: FeaturedBadgeRuleEntryValues[];
  active: boolean;
}

export interface FeaturedBadgeRuleGroupDeletePayload {
  tenantId: string | null;
  eventTypeId: number | null;
  eventSubTypeId: number | null;
}

export interface FeaturedBadgeRuleGroupTogglePayload extends FeaturedBadgeRuleGroupDeletePayload {
  active: boolean;
}

export interface FeaturedBadgeRuleEntriesDeletePayload {
  ids: number[];
}

export interface FeaturedBadgeRuleGroup {
  groupKey: string;
  id: number;
  tenantId: string | null;
  tenantName?: string | null;
  eventTypeId: number | null;
  eventSubTypeId: number | null;
  eventTypeName?: string;
  eventSubTypeName?: string | null;
  entries: FeaturedBadgeRule[];
  active: boolean;
}
